import React from "react";
import "../style.css";
import { RiUserShared2Line } from "react-icons/ri";
const ThreeSteps = () => {
  return (
    <section className="three-steps-section py-5" id="how-it-works">
      <div className="container">
        <h2 className="three-steps-title">Three Steps To Earn With Poll Sphere</h2>
        
        <div className="row mt-5">
          {/* Step 1 */}
          <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
            <div className="step-card">

              <div className="step-icon-wrapper">
               <RiUserShared2Line size={40} color="#ffffffff" />
              </div>
              <h3 className="step-title">Sign Up & Participate</h3>
              <p className="step-description">
                Create your account and start taking surveys on topics you care about
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
            <div className="step-card">
            
              <div className="step-icon-wrapper">
               <RiUserShared2Line size={40} color="rgb(255 255 255)" />
              </div>
              <h3 className="step-title">Earn Rewards</h3>
              <p className="step-description">
                Complete surveys and earn rewards that get added to your Poll Sphere wallet
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
            <div className="step-card">
          
              <div className="step-icon-wrapper">
             <RiUserShared2Line size={40} color="rgb(255 255 255)" />
              </div>
              <h3 className="step-title">Redeem Rewards</h3>
              <p className="step-description">
                Withdraw your earnings to your bank account or redeem as vouchers
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreeSteps;
